<!-- <mat-dialog-actions> -->
<div align="end">
    <button id="x" (click)="onNoClick()">
        X
    </button>
</div>
<!-- </mat-dialog-actions> -->
<!-- <mat-dialog-content> -->
<ngb-carousel id="myCarousel">
    <!-- <ol class="carousel-indicators">
            <li data-target="#myCarousel" *ngFor="let image of dataImage" data-slide-to="{{image.id}}"
                [class]="image.class"></li>
             <li data-target="#myCarousel" data-slide-to="1"></li>
        </ol> -->
    <ng-template ngbSlide *ngFor="let image of dataImage | activeslide: 'media_path': datapath">
        <div class="carousel-items " style="max-width: 756px; max-height: 425px; ">
            <img class=" " src="https://ros.com.sg/demo/rosapi/{{image.media_path}} " alt="" width="100%; ">
        </div>
    </ng-template>
    <!-- <ng-template ngbSlide>
        <div class="carousel-items ">
            <img class=" " src="./assets/ros_img/2.jpg " alt=" " width="100%; ">
        </div>
    </ng-template> -->
</ngb-carousel>
<!-- </mat-dialog-content> -->
